import { FC } from 'react'
import { Show, useCreatePath, useGetManyReference, useShowContext } from 'react-admin'

import type { EventRecord, ScaleRecord } from '@/data/source'

import { LoadingDisplay } from '../atoms/LoadingDisplay'
import { BackButton } from '../molecules/BackButton'
import { ScaleDetails } from '../pages/ScaleDetails'

const ShowRecord: FC = () => {
  const { record } = useShowContext<ScaleRecord>()
  const { data: events, isPending } = useGetManyReference<EventRecord>(
    'scale_events',
    {
      target: 'scaleRecordId',
      id: record?.id ?? '',
      sort: { field: 'startTime', order: 'DESC' },
      pagination: { page: 1, perPage: 1000 },
    },
    { enabled: record !== undefined },
  )
  if (!record || isPending) return <LoadingDisplay />

  return <ScaleDetails scale={record} events={events ?? []} />
}

const ScaleTitle: FC = () => {
  const { record } = useShowContext<ScaleRecord>()
  if (!record) return null
  return <span>{record.vessel === null ? record.scaleId : `${record.scaleId} · ${record.vessel}`}</span>
}

const BackToList: FC = () => {
  const createPath = useCreatePath()
  return <BackButton to={createPath({ resource: 'scales', type: 'list' })} label="resources.scales.actions.back_to_list" />
}

export const ScaleShow = () => (
  <Show title={<ScaleTitle />} actions={<BackToList />}>
    <ShowRecord />
  </Show>
)
